import { TimeTracking } from '@work4all/models/lib/Classes/TimeTracking.entity';
import { SortDirection } from '@work4all/models/lib/DataProvider';

import { SectionName } from '@work4all/utils/lib/mark-sections-by-date';

import { useTimeTrackingMaskActions } from '../../time-tracking-mask/hooks';
import { EntityTableV8, IEntityTableV8 } from '../entity-table/EntityTableV8';
import { useEntityDataTableV8 } from '../entity-table/use-entity-data-table-v8';
import schema from '../schemata/timeTracking-table-schema.json';

import { TimeTrackingCopyButtonCell } from './TimeTrackingCopyButtonCell';

const defaultSort = [{ field: 'date', direction: SortDirection.DESCENDING }];

const AVAILABLE_DATE_SECTIONS: SectionName[] = [
  'future',
  'today',
  'yesterday',
  'lastWeek',
  'thisMonth',
  'thisYear',
  'lastYear',
  'before',
  'unknown',
];

export function TimeTrackingTable(props: IEntityTableV8) {
  const dataTable = useEntityDataTableV8<TimeTracking, never>({
    ...props,
    schema: schema as never,
    defaultSort,
    cells: {
      CopyButton: TimeTrackingCopyButtonCell,
    },
    availableDateSections: AVAILABLE_DATE_SECTIONS,
    markWithDayNameForPastDaysThisWeek: true,
  });

  const actions = useTimeTrackingMaskActions(dataTable.selectedEntities?.[0]);

  return (
    <EntityTableV8
      {...props}
      {...dataTable}
      actions={actions}
      overrides={{ areas: null }}
    />
  );
}
